<!-- @format -->
<div>
   <div class="pull-right" style="margin-top: -44px">
      <button
         pButton
         type="button"
         class="btn btn-sm btn-primary"
         (click)="getSatellites($event)"
         label="Refresh"
      ></button>
   </div>

   <br />

   <div
      *ngIf="(satelliteSurveillances$ | async).satelliteSurveillance as satelliteSurveillance"
      style="margin-top: 4px"
   >
      <p-table
         #satelliteTable
         [columns]="columns"
         [value]="satelliteSurveillance"
         dataKey="satelliteId"
         selectionMode="single"
         [(selection)]="selectedSatellite"
         (onRowSelect)="onRowSelect($event)"
         [rowTrackBy]="satelliteTrackBy"
         [scrollable]="true"
         [rows]="50"
         scrollHeight="600px"
         [virtualScroll]="true"
         [virtualRowHeight]="45"
         (onFilter)="onFilterApply($event)"
         (firstChange)="firstChange($event)"
         [customSort]="true"
         (sortFunction)="applySort($event)"
      >
         <ng-template pTemplate="header" let-columns>
            <tr class="table-header-upper-row">
               <th
                  *ngFor="let col of columns"
                  [pSortableColumn]="col.field"
                  [style.width.px]="col.width"
                  style="padding-bottom: 0px"
               >
                  {{ col.header }}

                  <p-sortIcon
                     *ngIf="col.field !== 'totalDatasourcesCount' && col.field !== 'lastCheckinLogEvent'"
                     [field]="col.field"
                     ariaLabel="Activate to sort"
                     ariaLabelDesc="Activate to sort in descending order"
                     ariaLabelAsc="Activate to sort in ascending order"
                  ></p-sortIcon>
               </th>
            </tr>
            <tr class="table-header-lower-row table-admin">
               <th *ngFor="let column of columns" [ngSwitch]="column.field" style="padding-top: 0px">
                  <input
                     *ngSwitchCase="'autoremindAccount'"
                     pInputText
                     type="text"
                     (input)="satelliteTable.filter($event.target.value, column.field, column.filterMatchMode)"
                     placeholder="Search by account"
                     [style]="{ width: '100%', background: 'white', border: '1px solid #cccccc', color: 'black' }"
                  />
                  <div *ngSwitchCase="'lastCheckinLogEvent'"></div>
                  <div *ngSwitchCase="'moduleType'"></div>
                  <p-dropdown
                     *ngSwitchCase="'lastCheckin'"
                     [options]="selectLastCheckin"
                     [style]="{
                        width: '100%',
                        background: 'white',
                        border: '1px solid #cccccc',
                        color: 'black',
                        'padding-left': '16px',
                        'font-size': '10px'
                     }"
                     (onChange)="satelliteTable.filter($event.value, column.field, column.filterMatchMode)"
                  ></p-dropdown>

                  <p-multiSelect
                     [panelStyle]="{ minWidth: '100%' }"
                     *ngSwitchCase="'userStatus'"

                     [options]="userSchedulerStatusOptions$ | async"
                     [showHeader]="false"
                     [(ngModel)]="selectedUserSchedulerStatus"
                     [style]="{
                        width: '100%',
                        background: 'white',
                        border: '1px solid #cccccc',
                        color: 'black',
                        'padding-left': '16px',
                        'font-size': '10px'
                     }"
                     (onChange)="statusFilter($event, satelliteTable)"
                  >
                     <ng-template let-value pTemplate="selectedItems">
                        <div *ngFor="let status of value" class="ui-multiselected-item-token ui-corner-all">
                           <span *ngIf="value && value.length === 1">{{ status }}</span>
                        </div>
                        <span *ngIf="!value || value.length === 0" class="ui-multiselected-empty-token ui-corner-all"
                           >--Select--</span
                        >
                        <span *ngIf="value && value.length > 1" class="ui-multiselected-empty-token ui-corner-all"
                           >{{ value.length }} selected</span
                        >
                     </ng-template>
                     <ng-template let-userSchedulerStatus pTemplate="item">
                        <span class="user-scheduler-status-item">{{ userSchedulerStatus.label }} </span>
                        <div *ngIf="userSchedulerStatus.value === 'pause'">
                           <hr style="margin: 0" />
                        </div>
                     </ng-template>
                  </p-multiSelect>

                  <input
                     *ngSwitchCase="'satelliteVersion'"
                     pInputText
                     type="text"
                     [style]="{
                        width: '100%',
                        background: 'white',
                        border: '1px solid #cccccc',
                        color: 'black',
                        'padding-left': '16px',
                        'font-size': '10px'
                     }"
                     placeholder="Search by version"
                     (input)="satelliteTable.filter($event.target.value, column.field, 'contains')"
                  />

                  <p-multiSelect
                     *ngSwitchCase="'totalDatasourcesCount'"
                     [options]="selectDetails"
                     [style]="{
                        width: '98%',
                        background: 'white',
                        border: '1px solid #cccccc',
                        color: 'black',
                        'padding-left': '16px',
                        'font-size': '10px',
                        'margin-top': '2px'
                     }"
                     defaultLabel="More Filters "
                     (onChange)="detailsFilter($event.value, satelliteTable)"
                     tooltip="Click to set more filters on which satellites are listed"
                     tooltipStyleClass="ui-tooltip"
                     tooltipPosition="top"
                     [displaySelectedLabel]="false"
                     [showHeader]="false"
                  ></p-multiSelect>
               </th>
            </tr>
            <img *ngIf="satellitesLoading$ | async" src="img/loading.gif" />
         </ng-template>
         <ng-template pTemplate="body" let-satellite let-columns="columns">
            <tr
               [pSelectableRow]="satellite"
               class="table-row"
               *ngIf="satellite.autoremindAccount && satellite.autoremindAccount.length > 0"
            >
               <td *ngFor="let col of columns" [style.width.px]="col.width">
                  <span *ngIf="col.header === 'Account'">
                     <small>
                        <a
                           style="
                              color: #337ab7;
                              cursor: pointer;
                              font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif;
                           "
                           href="/admin/satellites/setup?userid={{ satellite.userId }}"
                           (click)="setRoute('admin/satellites/setup', 'userid', satellite.userId)"
                           >{{ satellite.autoremindAccount }}</a
                        >
                        <br />
                        <a
                           style="
                              color: #337ab7;
                              cursor: pointer;
                              font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif;
                           "
                           href="/admin/satellites/errors?user={{ satellite.autoremindAccount }}"
                           (click)="setRoute('admin/satellites/errors', 'user', satellite.autoremindAccount)"
                           >[view errors]</a
                        >
                     </small>
                  </span>
                  <span *ngIf="col.header === 'Installed On'">
                     <span *ngIf="satellite.lastCheckinLogEvent; else loading">
                        <small
                           *ngIf="
                              satellite.lastCheckinLogEvent !== undefined &&
                                 satellite.lastCheckinLogEvent !== null &&
                                 satellite.lastCheckinLogEvent.satelliteId === satellite.satelliteName;
                              else loading
                           "
                           style="font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif"
                        >
                           {{ satellite.lastCheckinLogEvent.satelliteHostname || "" }}
                        </small>
                     </span>
                  </span>
                  <span *ngIf="col.header === 'Type'">
                     <span
                        *ngIf="
                           satellite.otherUsersDatasourcesCount !== undefined &&
                           satellite.otherUsersDatasourcesCount > 0
                        "
                     >
                        <small
                           >Host <span *ngIf="satellite.moduleType">({{ satellite.moduleType }})</span></small
                        >
                        <div *ngIf="satellite.otherUsersDataSources as otherUsersDataSources; else loading">
                           <div
                              *ngIf="
                                 otherUsersDataSources.length > 0 &&
                                    satellite.lastCheckinLogEvent !== undefined &&
                                    satellite.lastCheckinLogEvent !== null &&
                                    satellite.lastCheckinLogEvent.satelliteId === satellite.satelliteName;
                                 else loading
                              "
                           >
                              <b>Hosted users:</b>
                              <br />
                              <div *ngFor="let datasource of otherUsersDataSources" style="margin-left: 5px">
                                 <span
                                    style="
                                       color: #337ab7;
                                       cursor: pointer;
                                       font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif;
                                    "
                                    (click)="setRoute('admin/satellites/setup', 'userid', datasource.userId)"
                                    >{{ datasource.userName }}
                                 </span>
                                 <span *ngIf="satellite.moduleType">({{ datasource.moduleType }})</span>
                                 <br />
                              </div>
                           </div>
                        </div>
                     </span>
                     <span
                        *ngIf="
                           satellite.otherUsersDatasourcesCount !== undefined &&
                           satellite.totalDatasourcesCount !== undefined &&
                           satellite.otherUsersDatasourcesCount === 0 &&
                           satellite.totalDatasourcesCount > 0 &&
                           satellite.moduleType !== undefined
                        "
                     >
                        <small style="font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif">{{
                           satellite.moduleType
                        }}</small>
                     </span>
                  </span>
                  <span *ngIf="col.field === 'lastCheckin'">
                     <small>{{
                        satellite.lastCheckin > 0 ? (satellite.lastCheckin | date: "yyyy-MM-dd HH:mm:ss") : ""
                     }}</small>
                     <br />
                     <small
                        style="color: #337ab7"
                        *ngIf="
                           satellite.lastCheckinLogEvent &&
                              satellite.lastCheckinLogEvent !== undefined &&
                              satellite.lastCheckinLogEvent !== null &&
                              satellite.lastCheckinLogEvent.satelliteId === satellite.satelliteName;
                           else loading
                        "
                     >
                        <span
                           tooltipPosition="top"
                           pTooltip="
                        {{ typeOfCheckToolTip(satellite) }}"
                        >
                           {{ displayLastCheckinWithPrefix(satellite) }}
                        </span>
                     </small>
                  </span>
                  <span *ngIf="col.field === 'userStatus'">
                     <small>{{ satellite.userStatus }}</small>
                     <br />
                     <small style="color: #337ab7; font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif">{{
                        satellite.schedulerState
                     }}</small>
                  </span>
                  <span *ngIf="col.field === 'satelliteVersion'">
                     <small style="font-family: Trebuchet MS, Tahoma, Verdana, Arial, sans-serif">{{
                        satellite.satelliteVersion
                     }}</small>
                  </span>
                  <span *ngIf="col.header === 'Details'">
                     <div *ngIf="satellite.lastCheckinLogEvent; else loading">
                        <small
                           *ngIf="
                              satellite.lastCheckinLogEvent !== undefined &&
                                 satellite.lastCheckinLogEvent !== null &&
                                 selectedSatellite !== undefined &&
                                 satellite.satelliteId === selectedSatellite.satelliteId;
                              else lastCheckinEventLoading
                           "
                        >
                           <span>Uptime: {{ convertToDayHourMinutes(satellite.lastCheckinLogEvent.systemUptime) }}</span
                           ><br />
                           Memory used: {{ satellite.lastCheckinLogEvent.usedMemory | filesize }}<br />
                           Log folder: {{ satellite.lastCheckinLogEvent.logFolderSize | filesize }}<br />
                           App folder: {{ satellite.lastCheckinLogEvent.applicationFolderSize | filesize }}<br />
                           Username: {{ satellite.lastCheckinLogEvent.satelliteSystemUsername }}<br />
                           Satellite ID: {{ satellite.satelliteName }}<br />
                           IP: {{ satellite.lastCheckinLogEvent.satelliteIP }}<br />
                           <!--CPUs: {{satellite.lastCheckinLogEvent.systemCPUs}}<br/>
                      Load Average: {{satellite.lastCheckinLogEvent.systemLoadAverage}}<br/>-->
                        </small>
                     </div>
                  </span>
               </td>
            </tr>

            <ng-template #lastCheckinEventLoading>
               <span
                  *ngIf="
                     satellite.lastCheckinLogEvent &&
                        (!selectedSatellite ||
                           (selectedSatellite && satellite.satelliteId !== selectedSatellite.satelliteId));
                     else loading
                  "
               >
                  <small>Uptime: {{ convertToDayHourMinutes(satellite.lastCheckinLogEvent.systemUptime) }}</small></span
               >
            </ng-template>

            <ng-template #loading>
               <img
                  style="width: 16px"
                  *ngIf="
                     !satellite.lastCheckinLogEvent &&
                        selectedSatellite &&
                        selectedSatellite !== null &&
                        satellite.satelliteId === selectedSatellite.satelliteId;
                     else clickForDetails
                  "
                  src="img/loading.gif"
               />
            </ng-template>

            <ng-template #clickForDetails>
               <span style="color: #808080; font-size: 11px"><small>[ click for details ]</small></span>
            </ng-template>
         </ng-template>
      </p-table>
   </div>
</div>
